export interface TokenStats {
  monthlyTokens: number;
  tokensUsed: number;
  recentUsage: number;
  usagePercentage: number;
}

export interface TokenAllocation {
  monthly_tokens: number;
  tokens_used: number;
  id: string;
  user_id: string;
  subscription_plan_id: string;
  reset_date: string;
  created_at: string;
  updated_at: string;
  can_create_documents: boolean;
}

export interface TokenUsageLog {
  id: string;
  user_id: string;
  service_name: string;
  tokens_used: number;
  created_at: string;
}

export interface TokenUsageParams {
  page: string;
  action: string;
  tokensUsed: number;
  metadata?: Record<string, any>;
}

export function isTokenAllocation(obj: any): obj is TokenAllocation {
  return obj && 
    typeof obj.monthly_tokens === 'number' && 
    typeof obj.tokens_used === 'number' &&
    typeof obj.id === 'string';
}

export function isTokenUsageLog(obj: any): obj is TokenUsageLog {
  return obj && 
    typeof obj.tokens_used === 'number' &&
    typeof obj.id === 'string' &&
    typeof obj.service_name === 'string';
}